"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableDebug = exports.enableRefresh = exports.navItemsEvent = exports.screenView = exports.clickEvent = exports.viewProduct = void 0;
var debug = false;
var checkObjIsFunction = function (targetObj, path) {
    if (typeof targetObj !== "undefined" && targetObj !== null) {
        var _a = path.split("."), currentPath = _a[0], otherPaths = _a.slice(1);
        if (otherPaths.length === 0 &&
            (targetObj[currentPath] === "function" || (typeof targetObj === "function" && path === ""))) {
            return true;
        }
        return typeof targetObj[currentPath] === "undefined"
            ? false
            : checkObjIsFunction(targetObj[currentPath], otherPaths.join("."));
    }
    return false;
};
var callBridge = function (callKey, data) {
    var JSBridgeCheckResult = checkObjIsFunction(window, "JSBridge." + callKey);
    var messageHandlerCheckResult = checkObjIsFunction(window, "webkit.messageHandlers." + callKey + ".postMessage");
    if (JSBridgeCheckResult) {
        window.JSBridge[callKey](JSON.stringify(data));
    }
    if (messageHandlerCheckResult) {
        window.webkit.messageHandlers[callKey].postMessage(data);
    }
    if (debug) {
        console.log("JSBridge/MessageHandler CheckResult: " + JSBridgeCheckResult + " " + messageHandlerCheckResult);
        console.log("Method: " + callKey + " Data:");
        console.log(JSON.stringify(data));
    }
};
exports.viewProduct = function (obj) {
    callBridge("viewProduct", obj);
};
exports.clickEvent = function (obj) {
    callBridge("clickEvent", obj);
};
exports.screenView = function (obj) {
    callBridge("screenView", obj);
};
exports.navItemsEvent = function (obj) {
    callBridge("navItemsEvent", obj);
};
exports.enableRefresh = function (obj) {
    callBridge("enableRefresh", obj);
};
exports.enableDebug = function () {
    debug = true;
};
